import React from 'react';
import { Theme, ThemeProps } from '@theme/base';
import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { mq } from '@styles/breakpoints';
import { useI18NextContext } from '@components/hooks';
import { TestId } from '@components/test-ids';
import { TelLink } from '@components/common/tel-link';

/* ***************** *
 *       Types       *
 * ***************** */

export interface CallToBookProps {
  theme: Theme;
  destination?: string;
  testId?: string;
  text?: string;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const Container: any = styled.div(({ theme }: ThemeProps) => ({
  alignContent: 'center',
  alignItems: 'center',
  background: theme.custom.colors.group10.lighter,
  borderRadius: 16,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.custom.spacing.medium * 1.5,
  [mq.small]: {
    flexDirection: 'row',
    padding: theme.custom.spacing.medium * 2
  }
}));

const InnerContainer: any = styled.div(({ theme }: ThemeProps) => ({
  textAlign: 'center',
  [mq.small]: {
    paddingLeft: theme.custom.spacing.medium * 2,
    textAlign: 'left'
  }
}));

const Image = styled.img({});

const Header: any = styled.h3(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h3 as any),
  color: theme.custom.colors.group1.dark,
  margin: 0
}));

const SubHeader: any = styled.h4(({ theme }: ThemeProps) => ({
  color: theme.custom.colors.group2.base,
  fontSize: '2.4rem',
  margin: 0,
  [mq.small]: {
    fontSize: '3.5rem'
  }
}));

const Text: any = styled.p({});

/* ********************************* *
 *    CallToBook                     *
 * ********************************* */

export const HolidaysCallToBookComponent = ({ theme, testId, destination, text }: CallToBookProps) => {
  const t: any = useI18NextContext();

  return (
    <Container data-testid={testId || TestId.callToBook.main} theme={theme}>
      <Image
        src={'/assets/images/contact/call-centre-new-360.jpg'}
        alt="Our Travel Specialists"
        width="180"
        height="180"
        loading={'lazy'}
      />
      <InnerContainer>
        <Header>
          {destination
            ? t('call-to-book--holidays-destination-header', { destination })
            : t('call-to-book--holidays-header')}
        </Header>
        <SubHeader>
          {t('call-to-book--holidays-subheader')}
          <TelLink phoneNumber={t('common__brand_telephone')} />
        </SubHeader>
        {text && <Text>{text}</Text>}
      </InnerContainer>
    </Container>
  );
};

export const HolidaysCallToBook = withTheme(HolidaysCallToBookComponent);
